import React from 'react';
import DatalayerInterface from '../../../modules/datalayer/datalayer.interface';
import { useSelector } from '@ecommerce/nest-ssr/common';

declare const window: any;

const Datalayer: React.FC = () => {
    const dataLayerData: DatalayerInterface[] = useSelector(
        (state: { dataLayerData: DatalayerInterface[]; }) => state.dataLayerData ?? []
    );

    if (typeof window !== 'undefined') {
        if (dataLayerData.length !== 0) {
            window.dataLayer = window.dataLayer || [];
            dataLayerData.forEach(item => window.dataLayer.push(item));
        }
    }

    return null;
};

export default Datalayer;
